<template>
  <a-steps class="section-steps" size="small">
    <div slot="progressDot" slot-scope="{ index }">
      <a-popover
        v-if="
          progress[index].type === 'big' && progress[index].finish !== 'finish'
        "
      >
        <template slot="content">
          <span>当前流程未进行</span>
        </template>
        <span
          class="pro-dot"
          :class="
            `${progress[index].type} ${progress[index].type}-${progress[index].finish}`
          "
        ></span>
      </a-popover>
      <span
        v-else
        class="pro-dot"
        :class="
          `${progress[index].type} ${progress[index].type}-${progress[index].finish}`
        "
      ></span>
    </div>
    <a-step
      v-for="item in progress"
      :key="item.id"
      :status="item.status"
      :class="`${item.type}-dot`"
      @click="jumpToAnchor(item.id)"
    >
      <div slot="title">
        {{ item.title }}
      </div>
    </a-step>
  </a-steps>
</template>

<script>
export default {
  props: {
    /**
     * type: small(小节点、副节点)， big(大节点、主节点)
     * finish: 当前节点完成状态，若为finish则展示为蓝心，否则展示为灰色
     * status: 节点完成状态，主要是过程横线的状态。finish则为
     */
    progress: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    /**
     * 跳转到响应锚点位置
     */
    jumpToAnchor(anchor) {
      if (document.getElementById(`${anchor}`)) {
        document.getElementById(`${anchor}`).scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .ant-steps-item-content {
    &:hover {
      cursor: pointer;
      .ant-steps-item-title {
        color: $primary-color;
      }
    }
  }
}
.pro-dot {
  display: block;
  &.big {
    width: 12px;
    height: 12px;
    background-color: $info-second-color;
    border-radius: 50%;
    margin-top: -2px;
  }
  &.big-finish {
    background-color: $primary-color;
  }
  &.small {
    width: 8px;
    height: 8px;
    border: 2px solid $info-second-color;
    border-radius: 4px;
  }
  &.small-finish {
    border: 4px solid $primary-color;
  }
}
.small-dot ::v-deep {
  .ant-steps-item-content {
    margin-top: -40px;
  }
}
</style>
